import {
    type ComponentType,
    createContext,
    useContext,
    useEffect,
    type FC
} from "react";
import type {
    BubblePartContentProps,
    BubbleGroupContextType,
    BubbleContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const BubbleContext = createContext<BubbleContextType | null>(null);

export const BubbleGroupContext = createContext<BubbleGroupContextType | null>(null);

export const useBubbleContext = () => {
    return useContext(BubbleContext);
};

export const useBubbleGroupContext = () => {
    return useContext(BubbleGroupContext);
};

export const withBubbleContext = <P extends object>(
    part: string,
    Content: ComponentType<BubblePartContentProps<P>>
): FC<P> => {
    const BubblePart: FC<P> = (props) => {
        const context = useBubbleContext();

        useEffect(() => {
            if(context) {
                return;
            }

            warnOnce({
                message: `Bubble.${part}: it must be rendered inside a Bubble.`
            });
        }, [
            context
        ]);

        if(!context) {
            return null;
        }

        return <Content
            {...props}
            context={context}
        />;
    };

    BubblePart.displayName = `Bubble.${part}`;

    return BubblePart;
};
